"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FUNCTION_MAPS_FOR_ORDER_COMPLETED = void 0;
exports.FUNCTION_MAPS_FOR_ORDER_COMPLETED = {
    functionMapNames: [
        'BACK',
        'MANAGER FUNCTIONS',
        'PRINT OPTIONS',
        'PRINT PREV RECEIPT',
        'SEND RECEIPT',
        'PRINT SHIFT SUMMARY',
        'MONEY IN/OUT',
        'END SHIFT',
        'SYSTEM_LOGOUT',
    ],
};
//# sourceMappingURL=functionMaps.js.map